import React from 'react';

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Hoisted to module scope (never define an equivalent of this inline inside
// a parent's render body) so it keeps a stable component identity across
// re-renders — an inline component recreated on every render gets fully
// remounted by React on every page change, which drops focus and briefly
// detaches its own Prev/Next buttons from the document mid-click. This
// was caught by InvoiceList.test.js when the bar first lived inline in
// InvoiceList.js; extracting it here (paired with the `usePagination` hook,
// see frontend/src/hooks/usePagination.js) makes that mistake structurally
// impossible to reintroduce at any of this component's other call sites.
export default function PaginationBar({
  totalCount,
  pageStart,
  pageSize,
  currentPage,
  totalPages,
  onPageSizeChange,
  onPrev,
  onNext,
  emptyLabel = 'No results found.',
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-6 py-3 bg-gray-50 border-t border-gray-200 text-sm text-gray-700">
      <div>
        {totalCount === 0
          ? emptyLabel
          : `Showing ${pageStart + 1}–${Math.min(pageStart + pageSize, totalCount)} of ${totalCount}`}
      </div>
      <div className="flex items-center gap-3">
        <label className="flex items-center gap-2">
          Per page
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(parseInt(e.target.value, 10))}
            className="rounded-md border border-gray-300 bg-white px-2 py-1"
          >
            {PAGE_SIZE_OPTIONS.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
        <div className="flex items-center gap-2">
          <button
            type="button"
            disabled={currentPage <= 1}
            onClick={onPrev}
            className="rounded-md bg-white px-3 py-1 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-40"
          >
            Prev
          </button>
          <span>Page {currentPage} / {totalPages}</span>
          <button
            type="button"
            disabled={currentPage >= totalPages}
            onClick={onNext}
            className="rounded-md bg-white px-3 py-1 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-40"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
